import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DATA_ROOM_MAX_STORAGE, ONE_GB } from 'data/global';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { formatMemoryLabel, formatPercentage, getPercentage } from 'utils';
import ProgressBar from 'components/ProgressBar';

import './DataRoomStorage.styles.scss';

type DataRoomStorageProps = {
  className?: string;
};

const DataRoomStorage: React.FC<DataRoomStorageProps> = (props) => {
  const { className } = props;

  const classes = classNames('data-room-storage', className);

  const {
    dataRoom: { storageCapacityUtilization },
  } = useContext(DataRoomContext);

  const { t } = useTranslation();

  const usedGB = useMemo(
    () => parseFloat(((storageCapacityUtilization || 0) / ONE_GB).toFixed(2)),
    [storageCapacityUtilization],
  );

  const usedPercentage = useMemo(
    () => Math.round(getPercentage(usedGB, DATA_ROOM_MAX_STORAGE)),
    [usedGB],
  );

  return (
    <div className={classes}>
      <p className="data-room-storage__title">{t('dataRoomStorage')}</p>
      <p>{t('trackHowMuchStorageDataRoom')}</p>

      <div className="data-room-storage__progress">
        <div>
          <p>
            {t('usedOfTotalStorage', {
              usedStorage: formatMemoryLabel(usedGB),
              totalStorage: formatMemoryLabel(DATA_ROOM_MAX_STORAGE),
            })}
          </p>

          <p>{formatPercentage(usedPercentage)}</p>
        </div>
        <ProgressBar percentage={usedPercentage} />
      </div>
    </div>
  );
};

export default DataRoomStorage;
